import axios from "axios";

/**
 * General-purpose axios instance for third-party API calls
 *
 * Use this for external APIs like Trustpilot, Google APIs, etc.
 * Does NOT include automatic locale injection or CMS-specific configuration.
 */
const axiosGeneral = axios.create();

export default axiosGeneral;
